module.exports = __webpack_public_path__ + "media/images/nav/icon_17-953d55703845d0c6874acb9039fab3aa.svg";